




































import { Component, Vue } from 'vue-property-decorator';
import firebase from 'firebase/app';
import 'firebase/database';
import { vxm } from '../../../store';
import Video from '@/components/VideoOnSite.vue';

@Component({
  components: {
    Video,
  },
})
export default class extends Vue {
  mounted() {
    const { update } = this.$route.query;
    if (update !== 'false') {
      const ref = firebase.database().ref('pr/new-user');
      ref.update({
        [`${vxm.login.getUserId}/step`]: '2.3',
      });
    }
  }
}
